package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.Place
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshots.SnapshotStateMap
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.efetivo.Datas
import br.com.htms.inspeccaocampo.data.efetivo.EfetivoApi
import br.com.htms.inspeccaocampo.data.efetivo.EfetivoDados
import br.com.htms.inspeccaocampo.data.efetivo.RegrasEfetivo
import br.com.htms.inspeccaocampo.data.ocorrencias.AcaoPlano
import br.com.htms.inspeccaocampo.data.ocorrencias.CampoOcorrencia
import br.com.htms.inspeccaocampo.data.ocorrencias.CamposOcorrencia
import br.com.htms.inspeccaocampo.data.ocorrencias.FotoOcorrencia
import br.com.htms.inspeccaocampo.data.ocorrencias.FuncOcorrencia
import br.com.htms.inspeccaocampo.data.ocorrencias.OcDatas
import br.com.htms.inspeccaocampo.data.ocorrencias.OcLog
import br.com.htms.inspeccaocampo.data.ocorrencias.Ocorrencia
import br.com.htms.inspeccaocampo.data.ocorrencias.OcorrenciasApi
import br.com.htms.inspeccaocampo.data.ocorrencias.OcorrenciasDados
import br.com.htms.inspeccaocampo.data.ocorrencias.TipoOcorrencia
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.platform.decodeToImageBitmap
import br.com.htms.inspeccaocampo.platform.formatDateTimeBr
import br.com.htms.inspeccaocampo.ui.kit.AvisoFaixa
import br.com.htms.inspeccaocampo.ui.kit.Campo
import br.com.htms.inspeccaocampo.ui.kit.CampoBusca
import br.com.htms.inspeccaocampo.ui.kit.BotaoCores
import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.PainelFixo
import br.com.htms.inspeccaocampo.ui.kit.CoresDash
import br.com.htms.inspeccaocampo.ui.kit.Celula
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalho
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalhoOrdenavel
import br.com.htms.inspeccaocampo.ui.kit.rememberOrdem
import br.com.htms.inspeccaocampo.ui.kit.ChipCor
import br.com.htms.inspeccaocampo.ui.kit.Kpi
import br.com.htms.inspeccaocampo.ui.kit.LinhaKpis
import br.com.htms.inspeccaocampo.ui.kit.LinhaTabela
import br.com.htms.inspeccaocampo.ui.kit.Par
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModal
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.TabelaPortal
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardOcorrencias
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import kotlinx.coroutines.launch

private enum class AbaOc(val rotulo: String) {
    PAINEL("Painel"),
    DASHBOARD("Dashboard"),
    LISTA("Ocorrências"),
    REGISTRAR("Registrar"),
    ACOES("Planos de ação"),
    TIPOS("Tipos e IDs"),
    OBRAS("Obras")
}

private val CorTrajeto = Color(0xFF6A1B9A)

private fun nomeTipoOc(d: OcorrenciasDados, o: Ocorrencia) =
    d.tipo(o.prefixo)?.nome?.ifBlank { null } ?: o.tipo.ifBlank { "Sem tipo" }

private fun obraOc(o: Ocorrencia) = o.campo("obra").ifBlank { o.local }

private fun corTipo(o: Ocorrencia, nomeTipo: String = ""): Color = when {
    o.campo("tipoAcid").equals("Trajeto", true) -> CorTrajeto
    o.ehAcidenteAtual(nomeTipo) -> PortalCores.Vermelho
    nomeTipo.contains("dano", true) || o.tipo.contains("dano", true) -> PortalCores.Laranja
    else -> PortalCores.Navy
}

private fun chipInvestigacao(o: Ocorrencia): Pair<String, Color> = when {
    o.investigacaoConcluida -> "Investigação concluída" to PortalCores.Verde
    o.investigacaoForaDoPrazo(OcDatas.hoje()) -> "Fora do prazo (7 dias)" to PortalCores.Vermelho
    o.statusInv.isBlank() -> "Investigação pendente" to PortalCores.Laranja
    else -> o.statusInv to PortalCores.Laranja
}

private fun chipAcao(a: AcaoPlano, hoje: String): Pair<String, Color> = when {
    a.concluida -> "Concluída" to PortalCores.Verde
    a.vencida(hoje) -> "Vencida" to PortalCores.Vermelho
    else -> a.campo("status").ifBlank { "Pendente" } to PortalCores.Laranja
}

private suspend fun escolherFoto(camera: Boolean): ByteArray? {
    PlatformServices.notifyPhotoPickerOpening()
    val foto = if (camera) PlatformServices.capturePhoto() else PlatformServices.pickImage()
    return foto?.let { PlatformServices.loadImageBytes(it.path) }
}

@Composable
fun SharedOcorrenciasScreen(controller: AppController) {
    val scope = rememberCoroutineScope()
    var dados by remember { mutableStateOf<OcorrenciasDados?>(null) }
    var erro by remember { mutableStateOf<String?>(null) }
    var carregando by remember { mutableStateOf(false) }
    var aviso by remember { mutableStateOf<Pair<String, Color>?>(null) }
    var aba by remember { mutableStateOf(AbaOc.PAINEL) }
    var editandoId by remember { mutableStateOf<String?>(null) }
    var versaoForm by remember { mutableStateOf(0) }
    var detalheId by remember { mutableStateOf<String?>(null) }
    var acaoAberta by remember { mutableStateOf<Pair<String, AcaoPlano?>?>(null) }
    val cacheFotos = remember { mutableStateMapOf<String, ImageBitmap>() }
    val authUser by controller.authUser.collectAsState()
    val hoje = remember { OcDatas.hoje() }

    fun recarregar() {
        carregando = true
        scope.launch {
            OcorrenciasApi.dados()
                .onSuccess {
                    dados = it
                    erro = null
                }
                .onFailure { erro = it.message ?: "Falha ao carregar as ocorrências." }
            carregando = false
        }
    }

    fun executar(okMsg: String, acao: suspend () -> Result<*>) {
        scope.launch {
            acao()
                .onSuccess {
                    aviso = okMsg to PortalCores.Verde
                    recarregar()
                }
                .onFailure { aviso = (it.message ?: "Falha ao salvar.") to PortalCores.Vermelho }
        }
    }

    fun novaOcorrencia() {
        editandoId = null
        versaoForm++
        aba = AbaOc.REGISTRAR
    }

    LaunchedEffect(Unit) { recarregar() }

    val d = dados
    val vencidas = d?.acoes.orEmpty().count { it.vencida(hoje) }
    val icone = mapOf(
        AbaOc.PAINEL to Icons.Filled.DateRange,
        AbaOc.DASHBOARD to Icons.Filled.Star,
        AbaOc.LISTA to Icons.Filled.List,
        AbaOc.REGISTRAR to Icons.Filled.Add,
        AbaOc.ACOES to Icons.Filled.CheckCircle,
        AbaOc.TIPOS to Icons.Filled.Settings,
        AbaOc.OBRAS to Icons.Filled.Place
    )
    val itens = AbaOc.entries.map {
        val rot = if (it == AbaOc.REGISTRAR && editandoId != null) "Editar $editandoId" else it.rotulo
        PortalMenuItem(it.name, rot, icone.getValue(it), destaque = it == AbaOc.ACOES && vencidas > 0)
    }

    PortalModulo(
        titulo = "Gestão de Ocorrências",
        itens = itens,
        selecionado = aba.name,
        onSelect = {
            val nova = AbaOc.valueOf(it)
            if (nova == AbaOc.REGISTRAR && aba != AbaOc.REGISTRAR) {
                editandoId = null
                versaoForm++
            }
            aba = nova
        },
        extraCabecalho = {
            BotaoPlanilha(controller, br.com.htms.inspeccaocampo.export.PlanilhaModulo.OCORRENCIAS)
            Spacer(Modifier.width(8.dp))
            PortalButton(onClick = { novaOcorrencia() }, enabled = d?.podeEditar != false) {
                Icon(Icons.Filled.Add, contentDescription = null, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(6.dp))
                Text("Nova ocorrência")
            }
            IconButton(onClick = { recarregar() }, enabled = !carregando) {
                Icon(Icons.Filled.Refresh, contentDescription = "Atualizar", tint = PortalCores.Navy)
            }
        }
    ) { largo ->
        aviso?.let { (msg, cor) -> AvisoFaixa(msg, cor) { aviso = null } }
        if (d == null) {
            if (erro != null) {
                CartaoSecao("Gestão de Ocorrências") {
                    Text(erro.orEmpty(), color = PortalCores.Vermelho)
                    PortalOutlinedButton(onClick = { recarregar() }) { Text("Tentar de novo") }
                }
            } else {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    CircularProgressIndicator(modifier = Modifier.size(22.dp), strokeWidth = 2.dp)
                    Text("Carregando as ocorrências...", color = PortalCores.CinzaTexto)
                }
            }
            return@PortalModulo
        }
        when (aba) {
            AbaOc.PAINEL -> AbaPainelOc(d, hoje, largo, abrir = { detalheId = it }, irPara = { aba = it })
            AbaOc.DASHBOARD -> DashboardOcorrencias(d, carregando) { recarregar() }
            AbaOc.LISTA -> AbaListaOc(d, largo) { detalheId = it }
            AbaOc.REGISTRAR -> FormOcorrencia(
                d = d,
                original = editandoId?.let { d.ocorrencia(it) },
                versao = versaoForm,
                largo = largo,
                cacheFotos = cacheFotos,
                onSalvo = { id, falhasFoto ->
                    aviso = (
                        if (falhasFoto == 0) "Ocorrência $id salva." to PortalCores.Verde
                        else "Ocorrência $id salva, mas $falhasFoto foto(s) não foram enviadas. Abra a ocorrência e tente anexar de novo." to PortalCores.Laranja
                        )
                    editandoId = null
                    versaoForm++
                    recarregar()
                    aba = AbaOc.LISTA
                    detalheId = id
                },
                onCancelar = {
                    editandoId = null
                    versaoForm++
                    aba = AbaOc.LISTA
                }
            )
            AbaOc.ACOES -> AbaAcoesOc(d, hoje, largo, onNova = { acaoAberta = "" to null }) { acaoAberta = it.ocId to it }
            AbaOc.TIPOS -> AbaTiposOc(d, authUser?.isAdmin == true, largo, ::executar) { msg, cor -> aviso = msg to cor }
            AbaOc.OBRAS -> AbaObrasOc(largo) { msg, cor -> aviso = msg to cor }
        }
    }

    val det = detalheId?.let { id -> d?.ocorrencia(id) }
    if (d != null && det != null) {
        DetalheOcorrencia(
            d = d,
            oc = det,
            hoje = hoje,
            cacheFotos = cacheFotos,
            onFechar = { detalheId = null },
            onEditar = {
                editandoId = det.id
                versaoForm++
                detalheId = null
                aba = AbaOc.REGISTRAR
            },
            onNovaAcao = { acaoAberta = det.id to null },
            onAbrirAcao = { acaoAberta = it.ocId to it },
            executar = ::executar,
            onExcluida = { detalheId = null }
        )
    }
    acaoAberta?.let { (ocId, acao) ->
        if (d != null) {
            ModalAcao(
                d, ocId, acao,
                onFechar = { acaoAberta = null },
                onExcluir = { id ->
                    acaoAberta = null
                    executar("Plano de ação $id excluído.") { OcorrenciasApi.excluirAcao(id) }
                }
            ) { id, oc, dadosAcao ->
                acaoAberta = null
                executar(if (id.isBlank()) "Plano de ação criado." else "Plano de ação $id salvo.") {
                    OcorrenciasApi.salvarAcao(id, oc, dadosAcao)
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Painel

@Composable
private fun AbaPainelOc(
    d: OcorrenciasDados,
    hoje: String,
    largo: Boolean,
    abrir: (String) -> Unit,
    irPara: (AbaOc) -> Unit
) {
    val ano = hoje.take(4)
    fun acidente(o: Ocorrencia) = o.ehAcidenteAtual(nomeTipoOc(d, o))
    val doAno = d.ocorrencias.filter { it.ano == ano }
    val acidentesAno = doAno.filter { acidente(it) }
    val ultimoAcidente = d.ocorrencias.filter { acidente(it) && Datas.valida(it.data) && it.data <= hoje }.maxOfOrNull { it.data }
    val diasSem = ultimoAcidente?.let { Datas.diff(hoje, it) }
    val abertas = d.acoes.count { !it.concluida }
    val vencidas = d.acoes.count { it.vencida(hoje) }
    val semEficacia = d.acoes.count { it.campo("eficacia").equals("Não", true) }
    val pendInv = d.ocorrencias.count { !it.investigacaoConcluida }
    val foraPrazo = d.ocorrencias.filter { it.investigacaoForaDoPrazo(hoje) }
    val diasAfast = doAno.sumOf { it.campo("diasAfast").replace(",", ".").toDoubleOrNull() ?: 0.0 }
    BotaoCores(
        listOf(
            "Ocorrências" to 0xFF1E5AA8,
            "Acidentes" to 0xFFC62828,
            "Dias sem acidente" to 0xFF1B7F3B,
            "Planos de ação abertos" to 0xFFE07B00,
            "Investigações abertas" to 0xFF6A1B9A,
            "Dias de afastamento" to 0xFFC62828
        )
    )

    LinhaKpis(largo) { m ->
        Kpi(
            "Ocorrências em $ano", doAno.size.toString(), Icons.Filled.List, m,
            cor = CoresDash.de("Ocorrências", 0xFF1E5AA8),
            legenda = "${d.ocorrencias.size} no total",
            onClick = { irPara(AbaOc.LISTA) }
        )
        Kpi(
            "Acidentes em $ano", acidentesAno.size.toString(), Icons.Filled.Warning, m,
            cor = CoresDash.de("Acidentes", 0xFFC62828),
            alerta = acidentesAno.isNotEmpty(),
            legenda = "${acidentesAno.count { it.comAfastamento() }} com afastamento"
        )
        Kpi(
            "Dias sem acidente",
            diasSem?.toString() ?: "—",
            Icons.Filled.DateRange,
            m,
            cor = CoresDash.de("Dias sem acidente", 0xFF1B7F3B),
            legenda = buildString {
                append(ultimoAcidente?.let { "Último em ${OcDatas.br(it)}" } ?: "Nenhum acidente registrado")
                d.meta?.let { append(" · meta $it") }
            }
        )
        Kpi(
            "Planos de ação abertos",
            abertas.toString(),
            Icons.Filled.CheckCircle,
            m,
            cor = CoresDash.de("Planos de ação abertos", 0xFFE07B00),
            alerta = vencidas > 0 || semEficacia > 0,
            legenda = "$vencidas vencido(s) · $semEficacia sem eficácia",
            onClick = { irPara(AbaOc.ACOES) }
        )
    }
    LinhaKpis(largo) { m ->
        Kpi(
            "Investigações abertas", pendInv.toString(), Icons.Filled.Warning, m,
            cor = CoresDash.de("Investigações abertas", 0xFF6A1B9A),
            alerta = foraPrazo.isNotEmpty(),
            legenda = if (foraPrazo.isEmpty()) "Nenhuma fora do prazo de 7 dias" else "${foraPrazo.size} fora do prazo de 7 dias"
        )
        Kpi(
            "Dias de afastamento",
            if (diasAfast % 1.0 == 0.0) diasAfast.toInt().toString() else diasAfast.toString(),
            Icons.Filled.DateRange, m,
            cor = CoresDash.de("Dias de afastamento", 0xFFC62828),
            alerta = diasAfast > 0,
            legenda = "Somados no ano"
        )
    }

    CartaoSecao("Por caracterização", subtitulo = "Marcas do relatório de investigação, no ano.") {
        ListaContagemOc(contagemCampo(doAno) { it.marcasCaracterizacao() }, "Nenhuma caracterização informada.")
    }
    CartaoSecao("Por classificação", subtitulo = "Classe 0 a 5, no ano.") {
        ListaContagemOc(
            doAno.groupingBy { it.classeRotulo() }.eachCount().toList().sortedByDescending { it.second },
            "Nenhuma classificação informada."
        )
    }
    CartaoSecao("Por obra", subtitulo = "Centro de custo informado no relatório, no ano.") {
        ListaContagemOc(
            doAno.filter { it.campo("obra").isNotBlank() }
                .groupingBy { it.campo("obra") }.eachCount().toList().sortedByDescending { it.second },
            "Nenhuma obra informada."
        )
    }

    CartaoSecao("Por tipo de ocorrência", subtitulo = "Prefixo de ID gerado ao registrar.") {
        d.tipos.forEach { t ->
            val lista = d.ocorrencias.filter { it.prefixo == t.prefixo }
            val acidentesTipo = lista.count { it.ano == ano && it.ehAcidenteAtual(t.nome) }
            Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                ChipCor(t.prefixo, if (t.ativo) PortalCores.Navy else PortalCores.CinzaTexto)
                Text(t.nome + if (t.ativo) "" else " (desativado)", Modifier.weight(1f), fontWeight = FontWeight.SemiBold, maxLines = 2)
                Text("${lista.count { it.ano == ano }} em $ano · $acidentesTipo acidente(s)", color = PortalCores.CinzaTexto)
            }
        }
    }

    CartaoSecao("Últimas ocorrências", subtitulo = "Clique para ver os detalhes, as fotos e os planos de ação.") {
        if (d.ocorrencias.isEmpty()) Text("Nenhuma ocorrência registrada.", color = PortalCores.CinzaTexto)
        d.ocorrencias.take(6).forEach { o -> LinhaOcorrenciaCompacta(o, nomeTipoOc(d, o)) { abrir(o.id) } }
    }

    if (foraPrazo.isNotEmpty()) {
        CartaoSecao("Investigações fora do prazo", subtitulo = "Abertas há mais de 7 dias.") {
            foraPrazo.take(8).forEach { o ->
                Row(Modifier.fillMaxWidth().clickable { abrir(o.id) }, horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                    ChipCor(o.id, PortalCores.Vermelho)
                    Text(nomeTipoOc(d, o), Modifier.weight(1f), maxLines = 1)
                    Text("${Datas.diff(hoje, o.data)} dias", color = PortalCores.Vermelho)
                }
            }
        }
    }

    val listaVencidas = d.acoes.filter { it.vencida(hoje) }
    if (listaVencidas.isNotEmpty()) {
        CartaoSecao("Planos de ação vencidos") {
            listaVencidas.forEach { a ->
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                    ChipCor(a.id, PortalCores.Vermelho)
                    Text(a.campo("acao"), Modifier.weight(1f), maxLines = 2)
                    Text("prazo ${OcDatas.br(a.campo("prazo"))}", color = PortalCores.Vermelho)
                }
            }
        }
    }
    val semEficaciaLista = d.acoes.filter { it.campo("eficacia").equals("Não", true) }
    if (semEficaciaLista.isNotEmpty()) {
        CartaoSecao("Ações sem eficácia", subtitulo = "Marcadas como não eficazes no plano.") {
            semEficaciaLista.take(8).forEach { a ->
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                    ChipCor(a.id, PortalCores.Laranja)
                    Text(a.campo("acao"), Modifier.weight(1f), maxLines = 2)
                    Text(a.campo("status").ifBlank { "Pendente" }, color = PortalCores.CinzaTexto)
                }
            }
        }
    }
}

private fun contagemCampo(itens: List<Ocorrencia>, marcas: (Ocorrencia) -> List<String>): List<Pair<String, Int>> {
    val mapa = linkedMapOf<String, Int>()
    itens.forEach { o -> marcas(o).forEach { m -> mapa[m] = (mapa[m] ?: 0) + 1 } }
    return mapa.toList().sortedByDescending { it.second }
}

@Composable
private fun ListaContagemOc(itens: List<Pair<String, Int>>, vazio: String) {
    if (itens.isEmpty()) {
        Text(vazio, color = PortalCores.CinzaTexto)
        return
    }
    itens.forEach { (nome, n) ->
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
            Text(nome, Modifier.weight(1f), maxLines = 2)
            Text(n.toString(), fontWeight = FontWeight.Bold, color = PortalCores.TextoForte)
        }
    }
}

@Composable
private fun LinhaOcorrenciaCompacta(o: Ocorrencia, nomeTipo: String, onClick: () -> Unit) {
    Column(
        Modifier.fillMaxWidth().clip(RoundedCornerShape(8.dp)).clickable { onClick() }.padding(vertical = 6.dp, horizontal = 4.dp),
        verticalArrangement = Arrangement.spacedBy(2.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            ChipCor(o.id, corTipo(o, nomeTipo))
            Text(OcDatas.br(o.data), fontWeight = FontWeight.SemiBold)
            Text(nomeTipo, color = PortalCores.CinzaTexto, modifier = Modifier.weight(1f), maxLines = 1)
            if (o.fotos.isNotEmpty()) Text("${o.fotos.size} foto(s)", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
        }
        val linha = listOf(o.classeRotulo().takeIf { it != "Não classificada" }, o.colaborador, obraOc(o))
            .filter { !it.isNullOrBlank() }.joinToString(" · ")
        if (linha.isNotBlank()) Text(linha, style = MaterialTheme.typography.bodySmall, maxLines = 2)
    }
    HorizontalDivider(color = PortalCores.Borda)
}

// ---------------------------------------------------------------- Lista

@Composable
private fun AbaListaOc(d: OcorrenciasDados, largo: Boolean, abrir: (String) -> Unit) {
    var busca by remember { mutableStateOf("") }
    var tipo by remember { mutableStateOf("") }
    var ano by remember { mutableStateOf("") }
    var ordemCol by remember { mutableStateOf("DATA") }
    var ordemAsc by remember { mutableStateOf(false) }
    val anos = d.ocorrencias.map { it.ano }.filter { it.length == 4 }.distinct().sortedDescending()
    val lista = d.ocorrencias.filter {
        it.contem(busca) && (tipo.isEmpty() || it.prefixo == tipo) && (ano.isEmpty() || it.ano == ano)
    }.sortedWith { a, b ->
        fun chave(o: Ocorrencia) = when (ordemCol) {
            "ID" -> o.id
            "TIPO" -> nomeTipoOc(d, o)
            "COLAB" -> o.colaborador
            "LOCAL" -> obraOc(o)
            "FOTOS" -> o.fotos.size.toString().padStart(5, '0')
            else -> o.data
        }
        val c = chave(a).compareTo(chave(b), ignoreCase = true)
        if (ordemAsc) c else -c
    }
    fun ordenar(col: String) {
        if (ordemCol == col) ordemAsc = !ordemAsc else { ordemCol = col; ordemAsc = col != "DATA" }
    }
    fun cres(col: String) = if (ordemCol == col) ordemAsc else null

    val filtrosOc: @Composable ColumnScope.() -> Unit = {
        CampoBusca(busca, { busca = it }, "Buscar por ID, colaborador, obra, classe ou descrição", Modifier.fillMaxWidth())
        Par(
            largo,
            { m -> Seletor("Tipo", listOf("" to "Todos") + d.tipos.map { it.prefixo to it.rotulo }, tipo, { tipo = it }, m) },
            { m -> Seletor("Ano", listOf("" to "Todos") + anos.map { it to it }, ano, { ano = it }, m) }
        )
    }
    CartaoSecao("Ocorrências", subtitulo = "${lista.size} de ${d.ocorrencias.size}. Clique numa ocorrência para ver detalhes e fotos.") {
        if (lista.isEmpty()) {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { filtrosOc() } }
            Text("Nenhuma ocorrência encontrada.", color = PortalCores.CinzaTexto)
        } else if (largo) {
            TabelaPortal(antes = filtrosOc, fixar = true, cabecalho = {
                CelulaCabecalhoOrdenavel("ID", 0.9f, cres("ID")) { ordenar("ID") }
                CelulaCabecalhoOrdenavel("Data", 0.9f, cres("DATA")) { ordenar("DATA") }
                CelulaCabecalhoOrdenavel("Tipo", 1.6f, cres("TIPO")) { ordenar("TIPO") }
                CelulaCabecalhoOrdenavel("Colaborador", 1.8f, cres("COLAB")) { ordenar("COLAB") }
                CelulaCabecalhoOrdenavel("Obra", 1.6f, cres("LOCAL")) { ordenar("LOCAL") }
                CelulaCabecalho("Investigação", 1.3f)
                CelulaCabecalhoOrdenavel("Fotos", 0.6f, cres("FOTOS")) { ordenar("FOTOS") }
            }) {
                lista.forEach { o ->
                    LinhaTabela(onClick = { abrir(o.id) }) {
                        Box(Modifier.weight(0.9f)) { ChipCor(o.id, corTipo(o, nomeTipoOc(d, o))) }
                        Celula(OcDatas.br(o.data), 0.9f)
                        Celula(
                            nomeTipoOc(d, o) + if (o.campo("tipoAcid").equals("Trajeto", true)) " (trajeto)" else "",
                            1.6f
                        )
                        Celula(o.colaborador.ifBlank { "—" }, 1.8f, negrito = true)
                        Celula(obraOc(o).ifBlank { "—" }, 1.6f)
                        Box(Modifier.weight(1.3f)) { chipInvestigacao(o).let { (t, c) -> ChipCor(t, c) } }
                        Celula(if (o.fotos.isEmpty()) "—" else o.fotos.size.toString(), 0.6f)
                    }
                }
            }
        } else {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { filtrosOc() } }
            lista.forEach { o -> LinhaOcorrenciaCompacta(o, nomeTipoOc(d, o)) { abrir(o.id) } }
        }
    }
}

// ---------------------------------------------------------------- Registrar / editar

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun FormOcorrencia(
    d: OcorrenciasDados,
    original: Ocorrencia?,
    versao: Int,
    largo: Boolean,
    cacheFotos: SnapshotStateMap<String, ImageBitmap>,
    onSalvo: (String, Int) -> Unit,
    onCancelar: () -> Unit
) {
    val scope = rememberCoroutineScope()
    val camposData = remember { (CamposOcorrencia.secoes.flatMap { it.campos }).filter { it.data }.map { it.chave }.toSet() }
    val valores = remember(original?.id, versao) {
        mutableStateMapOf<String, String>().apply {
            original?.dados?.forEach { (k, v) -> put(k, if (k in camposData) OcDatas.br(v) else v) }
            if (original == null) put("data", OcDatas.br(OcDatas.hoje()))
        }
    }
    val ativos = d.tipos.filter { it.ativo }
    var prefixo by remember(original?.id, versao) { mutableStateOf(original?.prefixo ?: ativos.firstOrNull()?.prefixo.orEmpty()) }
    val pendentes = remember(original?.id, versao) { mutableStateListOf<ByteArray>() }
    var salvando by remember { mutableStateOf(false) }
    var erroForm by remember(original?.id, versao) { mutableStateOf<String?>(null) }
    var lendoFoto by remember { mutableStateOf(false) }
    val tipoSel = d.tipo(prefixo)

    fun anexar(camera: Boolean) {
        lendoFoto = true
        scope.launch {
            val b = escolherFoto(camera)
            if (b != null) pendentes += b
            else if (!PlatformServices.consumeLastPhotoPickCancelled()) erroForm = "Não foi possível ler a foto escolhida."
            lendoFoto = false
        }
    }

    fun salvar() {
        erroForm = null
        val final = mutableMapOf<String, String>()
        for ((k, v) in valores) {
            if (k in camposData) {
                val iso = OcDatas.iso(v)
                if (iso == null) {
                    erroForm = "Data inválida em \"${CamposOcorrencia.rotulo(k)}\". Use dd/mm/aaaa."
                    return
                }
                final[k] = iso
            } else {
                final[k] = v.trim()
            }
        }
        if (final["data"].isNullOrBlank()) {
            erroForm = "Informe a data da ocorrência."
            return
        }
        if (original == null && tipoSel == null) {
            erroForm = "Selecione o tipo de ocorrência."
            return
        }
        if (original == null && final["tipoAcid"].isNullOrBlank() && !tipoSel?.tipoAcid.isNullOrBlank()) {
            final["tipoAcid"] = tipoSel?.tipoAcid.orEmpty()
        }
        salvando = true
        scope.launch {
            val r = if (original == null) OcorrenciasApi.criar(prefixo, final)
            else OcorrenciasApi.atualizar(original.id, final).map { original.id }
            r.onSuccess { id ->
                var falhas = 0
                pendentes.forEach { b -> OcorrenciasApi.enviarFoto(id, b, "").onFailure { falhas++ } }
                salvando = false
                onSalvo(id, falhas)
            }.onFailure {
                erroForm = it.message ?: "Falha ao salvar a ocorrência."
                salvando = false
            }
        }
    }

    CartaoSecao(
        if (original == null) "Registrar ocorrência" else "Editar ocorrência ${original.id}",
        subtitulo = if (original == null) "O ID é gerado automaticamente pelo tipo escolhido." else "O ID e o tipo não mudam na edição."
    ) {
        if (original == null) {
            Seletor("Tipo de ocorrência", ativos.map { it.prefixo to it.rotulo }, prefixo, { prefixo = it })
            tipoSel?.let {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    Text("ID que será gerado:", color = PortalCores.CinzaTexto)
                    ChipCor(it.proximoId, PortalCores.Navy)
                }
            }
        } else {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                ChipCor(original.id, corTipo(original))
                Text(original.tipo, fontWeight = FontWeight.SemiBold)
            }
        }
    }

    CamposOcorrencia.secoes.forEach { secao ->
        CartaoSecao(secao.titulo) {
            when {
                secao.campos.any { it.chave == "com1" } -> ComissaoCampos(d, valores, largo)
                secao.campos.any { it.chave == "obra" } -> {
                    CamposFormulario(secao.campos.filter { it.chave != "obra" }, valores, largo, d)
                    ObraCampo(d, valores)
                }
                secao.campos.any { it.chave == "colaborador" } -> {
                    ColaboradorCampo(d, valores)
                    CamposFormulario(secao.campos.filter { it.chave != "colaborador" }, valores, largo, d)
                }
                else -> CamposFormulario(secao.campos, valores, largo, d)
            }
        }
    }

    CartaoSecao("15. Anexos", subtitulo = "Foto no dia do ocorrido e registros fotográficos. Aparecem ao abrir a ocorrência.") {
        val existentes = original?.fotos.orEmpty()
        if (existentes.isEmpty() && pendentes.isEmpty()) Text("Nenhuma foto anexada.", color = PortalCores.CinzaTexto)
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            existentes.forEach { f -> FotoMiniatura(f.id, cacheFotos, 96.dp) {} }
            pendentes.forEachIndexed { i, b ->
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    MiniaturaBytes(b, 96.dp)
                    TextButton(onClick = { pendentes.removeAt(i) }) { Text("Remover", color = PortalCores.Vermelho) }
                }
            }
        }
        if (pendentes.isNotEmpty()) Text("${pendentes.size} foto(s) serão enviadas ao salvar.", color = PortalCores.CinzaTexto)
        Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
            PortalOutlinedButton(onClick = { anexar(false) }, enabled = !lendoFoto && !salvando) { Text("Anexar fotos") }
            if (PlatformServices.hasCamera) {
                PortalOutlinedButton(onClick = { anexar(true) }, enabled = !lendoFoto && !salvando) { Text("Tirar foto") }
            }
            if (lendoFoto) CircularProgressIndicator(modifier = Modifier.size(20.dp), strokeWidth = 2.dp)
        }
    }

    erroForm?.let { Text(it, color = PortalCores.Vermelho, fontWeight = FontWeight.SemiBold) }
    Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
        PortalButton(onClick = { salvar() }, enabled = !salvando && d.podeEditar) {
            Text(if (salvando) "Salvando..." else if (original == null) "Registrar ocorrência" else "Salvar alterações")
        }
        PortalOutlinedButton(onClick = onCancelar, enabled = !salvando) { Text("Cancelar") }
        if (salvando) CircularProgressIndicator(modifier = Modifier.size(20.dp), strokeWidth = 2.dp)
    }
}

/** Campos de uma linha em pares (tela larga); textos longos em largura total. Sugestões viram atalhos. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun CamposFormulario(
    campos: List<CampoOcorrencia>,
    valores: SnapshotStateMap<String, String>,
    largo: Boolean,
    d: OcorrenciasDados?
) {
    @Composable
    fun umCampo(c: CampoOcorrencia, m: Modifier) {
        Column(m, verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Campo(
                if (c.data) "${c.rotulo} (dd/mm/aaaa)" else c.rotulo,
                valores[c.chave].orEmpty(),
                numero = c.numero,
                linhas = c.linhas,
                modifier = Modifier.fillMaxWidth()
            ) { valores[c.chave] = filtrarCampo(c, it) }
            val usados = d?.ocorrencias.orEmpty().map { it.campo(c.chave) }
            val sugestoes = if (c.multiplo) c.sugestoes
            else if (c.sugestoes.isEmpty()) emptyList()
            else (c.sugestoes + usados).filter { it.isNotBlank() }.distinct().take(8)
            if (sugestoes.isNotEmpty()) {
                FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                    sugestoes.forEach { s ->
                        val marcas = valores[c.chave].orEmpty().split(",").map { it.trim() }.filter { it.isNotEmpty() }
                        val sel = if (c.multiplo) marcas.any { it.equals(s, ignoreCase = true) }
                        else valores[c.chave].orEmpty().equals(s, ignoreCase = true)
                        ChipCor(
                            s,
                            if (sel) PortalCores.Verde else PortalCores.CinzaTexto,
                            Modifier.clickable {
                                valores[c.chave] = if (!c.multiplo) s
                                else {
                                    val atual = marcas.filterNot { it.equals(s, ignoreCase = true) }.toMutableList()
                                    if (!sel) atual += s
                                    c.sugestoes.filter { opt -> atual.any { it.equals(opt, ignoreCase = true) } }
                                        .joinToString(", ")
                                }
                            }
                        )
                    }
                }
            }
        }
    }

    var i = 0
    while (i < campos.size) {
        val a = campos[i]
        val b = campos.getOrNull(i + 1)
        if (largo && a.linhas == 1 && b != null && b.linhas == 1) {
            Par(true, { m -> umCampo(a, m) }, { m -> umCampo(b, m) })
            i += 2
        } else {
            umCampo(a, Modifier.fillMaxWidth())
            i += 1
        }
    }
}

private fun pessoasDe(d: OcorrenciasDados) =
    d.funcionarios.filter { it.nome.isNotBlank() }.sortedBy { it.nome.lowercase() }

private fun rotuloPessoa(f: FuncOcorrencia) =
    listOf(f.nome, f.matricula).filter { it.isNotBlank() }.joinToString(" · ")

private fun idPeloNome(pessoas: List<FuncOcorrencia>, nome: String) =
    pessoas.firstOrNull { it.nome.equals(nome, ignoreCase = true) }?.id.orEmpty()

@Composable
private fun ComissaoCampos(d: OcorrenciasDados, valores: SnapshotStateMap<String, String>, largo: Boolean) {
    val pessoas = pessoasDe(d)
    val opcoes = listOf("" to "Selecione") + pessoas.map { it.id to rotuloPessoa(it) }
    (1..6).forEach { n ->
        val idSel = idPeloNome(pessoas, valores["com$n"].orEmpty())
        Par(
            largo,
            { m ->
                Seletor("Participante $n", opcoes, idSel, { id ->
                    val f = pessoas.firstOrNull { it.id == id }
                    valores["com$n"] = f?.nome.orEmpty()
                    valores["cargo$n"] = f?.funcao.orEmpty()
                }, modifier = m, embutido = true)
            },
            { m ->
                Campo("Cargo / função $n", valores["cargo$n"].orEmpty(), modifier = m) { valores["cargo$n"] = it }
            }
        )
    }
    Campo("Comissão (texto livre)", valores["comissao"].orEmpty(), linhas = 2, modifier = Modifier.fillMaxWidth()) {
        valores["comissao"] = it
    }
}

@Composable
private fun ObraCampo(d: OcorrenciasDados, valores: SnapshotStateMap<String, String>) {
    val obra = valores["obra"].orEmpty()
    val idSel = d.centros.firstOrNull {
        it.rotulo == obra || it.codigo == obra || it.nome.equals(obra, ignoreCase = true)
    }?.codigo.orEmpty()
    Seletor(
        "Obra",
        listOf("" to "Selecione") + d.centros.map { it.codigo to it.rotulo },
        idSel,
        { cod -> valores["obra"] = d.centros.firstOrNull { it.codigo == cod }?.rotulo.orEmpty() },
        embutido = true
    )
}

@Composable
private fun ColaboradorCampo(d: OcorrenciasDados, valores: SnapshotStateMap<String, String>) {
    val pessoas = pessoasDe(d)
    val idSel = idPeloNome(pessoas, valores["colaborador"].orEmpty())
    Seletor(
        "Nome",
        listOf("" to "Selecione") + pessoas.map { it.id to rotuloPessoa(it) },
        idSel,
        { id ->
            val f = pessoas.firstOrNull { it.id == id }
            valores["colaborador"] = f?.nome.orEmpty()
            valores["funcao"] = f?.funcao.orEmpty()
            valores["matricula"] = f?.matricula.orEmpty()
            valores["tempoEmpresa"] = f?.let { OcDatas.tempoEmpresa(it.admissao) }.orEmpty()
            valores["idade"] = f?.let { OcDatas.idade(it.nascimento) }.orEmpty()
        },
        embutido = true
    )
}

private fun filtrarCampo(c: CampoOcorrencia, bruto: String): String = when {
    c.numero -> bruto.filter { it.isDigit() }.take(6)
    c.data -> mascaraData(bruto)
    c.chave == "hora" || c.chave == "horasTrab" -> mascaraHora(bruto)
    else -> bruto
}

private fun mascaraData(bruto: String): String {
    val d = bruto.filter { it.isDigit() }.take(8)
    return buildString {
        d.forEachIndexed { i, ch ->
            if (i == 2 || i == 4) append('/')
            append(ch)
        }
    }
}

private fun mascaraHora(bruto: String): String {
    val d = bruto.filter { it.isDigit() }.take(4)
    return buildString {
        d.forEachIndexed { i, ch ->
            if (i == 2) append(':')
            append(ch)
        }
    }
}

// ---------------------------------------------------------------- Fotos

@Composable
private fun FotoMiniatura(fotoId: String, cache: SnapshotStateMap<String, ImageBitmap>, tamanho: Dp, onClick: () -> Unit) {
    var falhou by remember(fotoId) { mutableStateOf(false) }
    LaunchedEffect(fotoId) {
        if (cache[fotoId] == null) {
            OcorrenciasApi.baixarFoto(fotoId)
                .onSuccess { b -> decodeToImageBitmap(b)?.let { cache[fotoId] = it } ?: run { falhou = true } }
                .onFailure { falhou = true }
        }
    }
    val bmp = cache[fotoId]
    Box(
        Modifier.size(tamanho).clip(RoundedCornerShape(8.dp)).background(PortalCores.Borda).clickable { onClick() },
        contentAlignment = Alignment.Center
    ) {
        when {
            bmp != null -> Image(bmp, contentDescription = "Foto", modifier = Modifier.fillMaxSize(), contentScale = ContentScale.Crop)
            falhou -> Text("Falha", color = PortalCores.Vermelho, style = MaterialTheme.typography.bodySmall)
            else -> CircularProgressIndicator(modifier = Modifier.size(20.dp), strokeWidth = 2.dp)
        }
    }
}

@Composable
private fun MiniaturaBytes(bytes: ByteArray, tamanho: Dp) {
    val bmp = remember(bytes) { decodeToImageBitmap(bytes) }
    Box(Modifier.size(tamanho).clip(RoundedCornerShape(8.dp)).background(PortalCores.Borda), contentAlignment = Alignment.Center) {
        if (bmp != null) Image(bmp, contentDescription = "Foto", modifier = Modifier.fillMaxSize(), contentScale = ContentScale.Crop)
        else Text("Foto", color = PortalCores.CinzaTexto)
    }
}

// ---------------------------------------------------------------- Detalhe

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun DetalheOcorrencia(
    d: OcorrenciasDados,
    oc: Ocorrencia,
    hoje: String,
    cacheFotos: SnapshotStateMap<String, ImageBitmap>,
    onFechar: () -> Unit,
    onEditar: () -> Unit,
    onNovaAcao: () -> Unit,
    onAbrirAcao: (AcaoPlano) -> Unit,
    executar: (String, suspend () -> Result<*>) -> Unit,
    onExcluida: () -> Unit
) {
    val scope = rememberCoroutineScope()
    var fotoAberta by remember(oc.id) { mutableStateOf<Int?>(null) }
    var enviando by remember(oc.id) { mutableStateOf(false) }
    var msgFoto by remember(oc.id) { mutableStateOf<String?>(null) }
    var confirmarExclusao by remember(oc.id) { mutableStateOf(false) }
    var historico by remember(oc.id) { mutableStateOf<List<OcLog>?>(null) }

    fun anexar(camera: Boolean) {
        enviando = true
        msgFoto = null
        scope.launch {
            val b = escolherFoto(camera)
            if (b == null) {
                if (!PlatformServices.consumeLastPhotoPickCancelled()) msgFoto = "Não foi possível ler a foto escolhida."
                enviando = false
                return@launch
            }
            enviando = false
            executar("Foto anexada à ocorrência ${oc.id}.") { OcorrenciasApi.enviarFoto(oc.id, b, "") }
        }
    }

    PortalModal(onFechar = onFechar, larguraMax = 960.dp) {
        CartaoSecao(
            "${oc.id} · ${oc.tipo}",
            subtitulo = "Registrada por ${oc.createdBy.ifBlank { "—" }} · atualizada em ${formatDateTimeBr(oc.updatedAt)} por ${oc.updatedBy.ifBlank { "—" }}",
            acoes = { TextButton(onClick = onFechar) { Text("Fechar") } }
        ) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                ChipCor(OcDatas.br(oc.data) + oc.campo("hora").let { if (it.isBlank()) "" else " às $it" }, PortalCores.Navy)
                if (oc.campo("tipoAcid").isNotBlank()) ChipCor(oc.campo("tipoAcid"), if (oc.campo("tipoAcid").equals("Trajeto", true)) CorTrajeto else PortalCores.Navy)
                if (oc.campo("classificacao").isNotBlank()) ChipCor(oc.campo("classificacao"), corTipo(oc))
                chipInvestigacao(oc).let { (t, c) -> ChipCor(t, c) }
            }
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                if (d.podeEditar) {
                PortalButton(onClick = onEditar) {
                    Icon(Icons.Filled.Edit, contentDescription = null, modifier = Modifier.size(16.dp))
                    Spacer(Modifier.width(6.dp))
                    Text("Editar")
                }
                }
                if (d.podeExcluir) {
                    PortalOutlinedButton(onClick = { confirmarExclusao = true }) { Text("Excluir", color = PortalCores.Vermelho) }
                }
            }
            if (confirmarExclusao) {
                Text("Excluir a ocorrência ${oc.id}? Ela sai das listas, mas continua guardada no banco.", color = PortalCores.Vermelho)
                Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    PortalButton(onClick = {
                        confirmarExclusao = false
                        onExcluida()
                        executar("Ocorrência ${oc.id} excluída.") { OcorrenciasApi.excluir(oc.id) }
                    }) { Text("Confirmar exclusão") }
                    PortalOutlinedButton(onClick = { confirmarExclusao = false }) { Text("Cancelar") }
                }
            }
        }

        Spacer(Modifier.size(12.dp))
        CartaoSecao("15. Anexos (${oc.fotos.size})", subtitulo = "Foto no dia do ocorrido e registros fotográficos. Clique numa foto para ampliar.") {
            if (oc.fotos.isEmpty()) Text("Nenhuma foto anexada.", color = PortalCores.CinzaTexto)
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                oc.fotos.forEachIndexed { i, f -> FotoMiniatura(f.id, cacheFotos, 120.dp) { fotoAberta = i } }
            }
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                PortalOutlinedButton(onClick = { anexar(false) }, enabled = !enviando) { Text("Anexar fotos") }
                if (PlatformServices.hasCamera) PortalOutlinedButton(onClick = { anexar(true) }, enabled = !enviando) { Text("Tirar foto") }
                if (enviando) CircularProgressIndicator(modifier = Modifier.size(20.dp), strokeWidth = 2.dp)
            }
            msgFoto?.let { Text(it, color = PortalCores.Vermelho) }
        }

        CamposOcorrencia.secoes.forEach { secao ->
            val preenchidos = secao.campos.filter { oc.campo(it.chave).isNotBlank() }
            if (preenchidos.isEmpty()) return@forEach
            Spacer(Modifier.size(12.dp))
            CartaoSecao(secao.titulo) {
                preenchidos.forEach { c ->
                    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                        Text(c.rotulo, color = PortalCores.CinzaTexto, style = MaterialTheme.typography.labelMedium)
                        Text(if (c.data) OcDatas.br(oc.campo(c.chave)) else oc.campo(c.chave))
                    }
                }
            }
        }

        Spacer(Modifier.size(12.dp))
        val acoes = d.acoesDe(oc.id)
        CartaoSecao(
            "Planos de ação (${acoes.size})",
            acoes = { TextButton(onClick = onNovaAcao) { Text("+ Novo plano") } }
        ) {
            if (acoes.isEmpty()) Text("Nenhum plano de ação para esta ocorrência.", color = PortalCores.CinzaTexto)
            acoes.forEach { a ->
                Row(
                    Modifier.fillMaxWidth().clip(RoundedCornerShape(6.dp)).clickable { onAbrirAcao(a) }.padding(6.dp),
                    horizontalArrangement = Arrangement.spacedBy(10.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    ChipCor(a.id, PortalCores.Navy)
                    Text(a.campo("acao"), Modifier.weight(1f), maxLines = 2)
                    chipAcao(a, hoje).let { (t, c) -> ChipCor(t, c) }
                }
            }
        }

        Spacer(Modifier.size(12.dp))
        CartaoSecao("Histórico de alterações") {
            val h = historico
            if (h == null) {
                PortalOutlinedButton(onClick = {
                    scope.launch { historico = OcorrenciasApi.log(oc.id).getOrElse { emptyList() } }
                }) { Text("Ver histórico") }
            } else if (h.isEmpty()) {
                Text("Sem registros.", color = PortalCores.CinzaTexto)
            } else {
                h.forEach { l ->
                    Text(
                        "${formatDateTimeBr(l.createdAt)} · ${l.nome.ifBlank { l.usuario }}: ${l.txt}",
                        style = MaterialTheme.typography.bodySmall
                    )
                }
            }
        }
    }

    fotoAberta?.let { idx ->
        val f = oc.fotos.getOrNull(idx)
        if (f == null) {
            fotoAberta = null
        } else {
            FotoAmpliada(
                f = f,
                posicao = "${idx + 1} de ${oc.fotos.size}",
                cache = cacheFotos,
                podeRemover = d.master || f.createdBy.equals(d.usuario, ignoreCase = true),
                onAnterior = if (idx > 0) ({ fotoAberta = idx - 1 }) else null,
                onProxima = if (idx < oc.fotos.size - 1) ({ fotoAberta = idx + 1 }) else null,
                onRemover = {
                    fotoAberta = null
                    executar("Foto removida.") { OcorrenciasApi.excluirFoto(f.id) }
                },
                onFechar = { fotoAberta = null }
            )
        }
    }
}

@Composable
private fun FotoAmpliada(
    f: FotoOcorrencia,
    posicao: String,
    cache: SnapshotStateMap<String, ImageBitmap>,
    podeRemover: Boolean,
    onAnterior: (() -> Unit)?,
    onProxima: (() -> Unit)?,
    onRemover: () -> Unit,
    onFechar: () -> Unit
) {
    var confirmar by remember(f.id) { mutableStateOf(false) }
    PortalModal(onFechar = onFechar, larguraMax = 1100.dp) {
        CartaoSecao(
            "Foto $posicao",
            subtitulo = "Anexada por ${f.createdBy.ifBlank { "—" }} em ${formatDateTimeBr(f.createdAt)}" + if (f.legenda.isNotBlank()) " · ${f.legenda}" else "",
            acoes = { TextButton(onClick = onFechar) { Text("Fechar") } }
        ) {
            val bmp = cache[f.id]
            Box(Modifier.fillMaxWidth().heightIn(min = 200.dp, max = 640.dp), contentAlignment = Alignment.Center) {
                if (bmp != null) {
                    Image(bmp, contentDescription = "Foto", modifier = Modifier.fillMaxWidth().heightIn(max = 640.dp), contentScale = ContentScale.Fit)
                } else {
                    FotoMiniatura(f.id, cache, 200.dp) {}
                }
            }
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                PortalOutlinedButton(onClick = { onAnterior?.invoke() }, enabled = onAnterior != null) { Text("Anterior") }
                PortalOutlinedButton(onClick = { onProxima?.invoke() }, enabled = onProxima != null) { Text("Próxima") }
                Spacer(Modifier.weight(1f))
                if (podeRemover) {
                    if (confirmar) {
                        PortalButton(onClick = onRemover) { Text("Confirmar remoção") }
                        TextButton(onClick = { confirmar = false }) { Text("Cancelar") }
                    } else {
                        TextButton(onClick = { confirmar = true }) { Text("Remover foto", color = PortalCores.Vermelho) }
                    }
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Planos de ação

@Composable
private fun AbaAcoesOc(d: OcorrenciasDados, hoje: String, largo: Boolean, onNova: () -> Unit, abrir: (AcaoPlano) -> Unit) {
    var filtro by remember { mutableStateOf("abertas") }
    val lista = d.acoes.filter {
        when (filtro) {
            "abertas" -> !it.concluida
            "vencidas" -> it.vencida(hoje)
            "concluidas" -> it.concluida
            else -> true
        }
    }
    CartaoSecao(
        "Planos de ação",
        subtitulo = "IDs PA-001, PA-002... gerados automaticamente. Clique para editar.",
        acoes = { PortalButton(onClick = onNova) { Text("Novo plano de ação") } }
    ) {
        val filtroAcoes: @Composable androidx.compose.foundation.layout.ColumnScope.() -> Unit = {
            Seletor(
                "Mostrar",
                listOf("abertas" to "Abertos", "vencidas" to "Vencidos", "concluidas" to "Concluídos", "todas" to "Todos"),
                filtro,
                { filtro = it },
                Modifier.fillMaxWidth(if (largo) 0.4f else 1f)
            )
        }
        if (lista.isEmpty()) {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp), content = filtroAcoes) }
            Text("Nenhum plano de ação neste filtro.", color = PortalCores.CinzaTexto)
        } else if (largo) {
            val ordem = rememberOrdem("PRAZO")
            val linhas = ordem.aplicar(lista) { a ->
                when (ordem.col) {
                    "OC" -> a.ocId
                    "ACAO" -> a.campo("acao")
                    "RESP" -> a.campo("resp")
                    "PRAZO" -> a.campo("prazo")
                    "STATUS" -> if (a.concluida) "2" else if (a.vencida(hoje)) "0" else "1"
                    else -> a.id
                }
            }
            TabelaPortal(antes = filtroAcoes, fixar = true, cabecalho = {
                CelulaCabecalhoOrdenavel("ID", 0.8f, ordem.marca("ID")) { ordem.clique("ID") }
                CelulaCabecalhoOrdenavel("Ocorrência", 0.9f, ordem.marca("OC")) { ordem.clique("OC") }
                CelulaCabecalhoOrdenavel("Ação", 3f, ordem.marca("ACAO")) { ordem.clique("ACAO") }
                CelulaCabecalhoOrdenavel("Responsável", 1.4f, ordem.marca("RESP")) { ordem.clique("RESP") }
                CelulaCabecalhoOrdenavel("Prazo", 0.9f, ordem.marca("PRAZO")) { ordem.clique("PRAZO") }
                CelulaCabecalhoOrdenavel("Status", 1.1f, ordem.marca("STATUS")) { ordem.clique("STATUS") }
            }) {
                linhas.forEach { a ->
                    LinhaTabela(onClick = { abrir(a) }) {
                        Celula(a.id, 0.8f, negrito = true)
                        Celula(a.ocId.ifBlank { "—" }, 0.9f)
                        Celula(a.campo("acao"), 3f)
                        Celula(a.campo("resp").ifBlank { "—" }, 1.4f)
                        Celula(OcDatas.br(a.campo("prazo")).ifBlank { "—" }, 0.9f, cor = if (a.vencida(hoje)) PortalCores.Vermelho else PortalCores.Texto)
                        Box(Modifier.weight(1.1f)) { chipAcao(a, hoje).let { (t, c) -> ChipCor(t, c) } }
                    }
                }
            }
        } else {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp), content = filtroAcoes) }
            lista.forEach { a ->
                Column(
                    Modifier.fillMaxWidth().clip(RoundedCornerShape(8.dp)).clickable { abrir(a) }.padding(6.dp),
                    verticalArrangement = Arrangement.spacedBy(4.dp)
                ) {
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                        ChipCor(a.id, PortalCores.Navy)
                        if (a.ocId.isNotBlank()) Text(a.ocId, color = PortalCores.CinzaTexto)
                        Spacer(Modifier.weight(1f))
                        chipAcao(a, hoje).let { (t, c) -> ChipCor(t, c) }
                    }
                    Text(a.campo("acao"))
                    Text(
                        listOf(a.campo("resp"), a.campo("prazo").let { if (it.isBlank()) "" else "prazo ${OcDatas.br(it)}" })
                            .filter { it.isNotBlank() }.joinToString(" · "),
                        color = PortalCores.CinzaTexto,
                        style = MaterialTheme.typography.bodySmall
                    )
                }
                HorizontalDivider(color = PortalCores.Borda)
            }
        }
    }
}

@Composable
private fun ModalAcao(
    d: OcorrenciasDados,
    ocIdInicial: String,
    acao: AcaoPlano?,
    onFechar: () -> Unit,
    onExcluir: (String) -> Unit,
    onSalvar: (String, String, Map<String, String>) -> Unit
) {
    val camposData = CamposOcorrencia.acao.filter { it.data }.map { it.chave }.toSet()
    val valores = remember(acao?.id) {
        mutableStateMapOf<String, String>().apply {
            acao?.dados?.forEach { (k, v) -> put(k, if (k in camposData) OcDatas.br(v) else v) }
            if (acao == null) put("status", "Pendente")
        }
    }
    var ocId by remember(acao?.id) { mutableStateOf(acao?.ocId ?: ocIdInicial) }
    var erro by remember(acao?.id) { mutableStateOf<String?>(null) }
    var confirmarExclusao by remember(acao?.id) { mutableStateOf(false) }

    PortalModal(onFechar = onFechar, larguraMax = 760.dp) {
        CartaoSecao(
            if (acao == null) "Novo plano de ação" else "Plano de ação ${acao.id}",
            subtitulo = if (acao == null) "O ID (PA-###) é gerado ao salvar." else "Atualizado por ${acao.updatedBy.ifBlank { "—" }}",
            acoes = { TextButton(onClick = onFechar) { Text("Fechar") } }
        ) {
            Seletor(
                "Ocorrência",
                listOf("" to "Sem ocorrência vinculada") + d.ocorrencias.map { it.id to "${it.id} — ${OcDatas.br(it.data)} ${it.colaborador}".trim() },
                ocId,
                { ocId = it }
            )
            CamposFormulario(CamposOcorrencia.acao, valores, largo = true, d = null)
            erro?.let { Text(it, color = PortalCores.Vermelho) }
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                PortalButton(onClick = {
                    val final = mutableMapOf<String, String>()
                    for ((k, v) in valores) {
                        if (k in camposData) {
                            val iso = OcDatas.iso(v)
                            if (iso == null) {
                                erro = "Data inválida em \"${CamposOcorrencia.rotulo(k)}\". Use dd/mm/aaaa."
                                return@PortalButton
                            }
                            final[k] = iso
                        } else {
                            final[k] = v.trim()
                        }
                    }
                    if (final["acao"].isNullOrBlank()) {
                        erro = "Descreva a ação."
                        return@PortalButton
                    }
                    onSalvar(acao?.id.orEmpty(), ocId, final)
                }, enabled = d.podeEditar) { Text("Salvar") }
                PortalOutlinedButton(onClick = onFechar) { Text("Cancelar") }
                Spacer(Modifier.weight(1f))
                if (acao != null && d.podeExcluir) {
                    if (confirmarExclusao) {
                        TextButton(onClick = { onExcluir(acao.id) }) { Text("Confirmar exclusão", color = PortalCores.Vermelho) }
                    } else {
                        TextButton(onClick = { confirmarExclusao = true }) { Text("Excluir", color = PortalCores.Vermelho) }
                    }
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Tipos e IDs

@Composable
private fun AbaTiposOc(
    d: OcorrenciasDados,
    admin: Boolean,
    largo: Boolean,
    executar: (String, suspend () -> Result<*>) -> Unit,
    avisar: (String, Color) -> Unit
) {
    val podeTipos = admin || d.master
    val scope = rememberCoroutineScope()
    var prefixo by remember { mutableStateOf("") }
    var nome by remember { mutableStateOf("") }
    var tipoAcid by remember { mutableStateOf("") }
    var meta by remember(d.meta) { mutableStateOf(d.meta?.toString().orEmpty()) }
    var importando by remember { mutableStateOf(false) }
    var corrigindo by remember { mutableStateOf<TipoOcorrencia?>(null) }
    var nomeCorrecao by remember { mutableStateOf("") }
    var prefixoCorrecao by remember { mutableStateOf("") }
    var tipoAcidCorrecao by remember { mutableStateOf("") }
    val prefixoLimpo = prefixo.uppercase().filter { it in 'A'..'Z' }.take(6)

    CartaoSecao(
        "Tipos de ocorrência e prefixos de ID",
        subtitulo = "O número é sequencial por tipo (ex.: OAT-001, OAT-002...). Tipos desativados não aparecem para novos registros."
    ) {
        if (largo) {
            val ordem = rememberOrdem("PREFIXO")
            val tipos = ordem.aplicar(d.tipos) { t ->
                when (ordem.col) {
                    "NOME" -> t.nome
                    "TIPO" -> t.tipoAcid
                    "QTD" -> d.ocorrencias.count { it.prefixo == t.prefixo }.toString().padStart(6, '0')
                    "PROX" -> t.proximoId
                    "SIT" -> if (t.ativo) "0" else "1"
                    else -> t.prefixo
                }
            }
            TabelaPortal(cabecalho = {
                CelulaCabecalhoOrdenavel("Prefixo", 0.8f, ordem.marca("PREFIXO")) { ordem.clique("PREFIXO") }
                CelulaCabecalhoOrdenavel("Nome", 2.2f, ordem.marca("NOME")) { ordem.clique("NOME") }
                CelulaCabecalhoOrdenavel("Típico/Trajeto padrão", 1.3f, ordem.marca("TIPO")) { ordem.clique("TIPO") }
                CelulaCabecalhoOrdenavel("Registros", 0.8f, ordem.marca("QTD")) { ordem.clique("QTD") }
                CelulaCabecalhoOrdenavel("Próximo ID", 1f, ordem.marca("PROX")) { ordem.clique("PROX") }
                CelulaCabecalhoOrdenavel("Situação", 1.2f, ordem.marca("SIT")) { ordem.clique("SIT") }
            }) {
                tipos.forEach { t ->
                    LinhaTabela {
                        Box(Modifier.weight(0.8f)) { ChipCor(t.prefixo, if (t.ativo) PortalCores.Navy else PortalCores.CinzaTexto) }
                        Celula(t.nome, 2.2f, negrito = true)
                        Celula(t.tipoAcid.ifBlank { "—" }, 1.3f)
                        Celula(d.ocorrencias.count { it.prefixo == t.prefixo }.toString(), 0.8f)
                        Celula(t.proximoId, 1f)
                        Box(Modifier.weight(1.2f)) {
                            if (podeTipos) {
                                Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                                    TextButton(onClick = {
                                        corrigindo = t
                                        nomeCorrecao = t.nome
                                        prefixoCorrecao = t.prefixo
                                        tipoAcidCorrecao = t.tipoAcid
                                    }) { Text("Editar", color = PortalCores.Navy) }
                                    TextButton(onClick = {
                                        executar(if (t.ativo) "Tipo ${t.prefixo} desativado." else "Tipo ${t.prefixo} reativado.") {
                                            OcorrenciasApi.atualizarTipo(t.prefixo, t.nome, t.tipoAcid, !t.ativo)
                                        }
                                    }) { Text(if (t.ativo) "Desativar" else "Reativar", color = if (t.ativo) PortalCores.Vermelho else PortalCores.Verde) }
                                }
                            } else {
                                ChipCor(if (t.ativo) "Ativo" else "Desativado", if (t.ativo) PortalCores.Verde else PortalCores.CinzaTexto)
                            }
                        }
                    }
                }
            }
        } else {
            d.tipos.forEach { t ->
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                    ChipCor(t.prefixo, if (t.ativo) PortalCores.Navy else PortalCores.CinzaTexto)
                    Column(Modifier.weight(1f)) {
                        Text(t.nome, fontWeight = FontWeight.SemiBold)
                        Text("Próximo: ${t.proximoId}${if (t.ativo) "" else " · desativado"}", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
                    }
                    if (podeTipos) {
                        TextButton(onClick = {
                            corrigindo = t
                            nomeCorrecao = t.nome
                            prefixoCorrecao = t.prefixo
                            tipoAcidCorrecao = t.tipoAcid
                        }) { Text("Editar") }
                        TextButton(onClick = {
                            executar(if (t.ativo) "Tipo ${t.prefixo} desativado." else "Tipo ${t.prefixo} reativado.") {
                                OcorrenciasApi.atualizarTipo(t.prefixo, t.nome, t.tipoAcid, !t.ativo)
                            }
                        }) { Text(if (t.ativo) "Desativar" else "Reativar") }
                    }
                }
            }
        }
    }

    CartaoSecao("Adicionar tipo (novo ID)", subtitulo = "Ex.: OCA — Acidente Com Afastamento. Prefixo, nome e típico/trajeto podem ser editados depois.") {
        Par(
            largo,
            { m -> Campo("Prefixo (1 a 6 letras)", prefixoLimpo, modifier = m) { prefixo = it } },
            { m -> Campo("Nome do tipo", nome, modifier = m) { nome = it } }
        )
        Seletor("Típico / Trajeto padrão", listOf("" to "Não definir", "Típico" to "Típico", "Trajeto" to "Trajeto"), tipoAcid, { tipoAcid = it })
        if (prefixoLimpo.isNotEmpty()) {
            Text("Os IDs serão: $prefixoLimpo-001, $prefixoLimpo-002...", color = PortalCores.CinzaTexto)
        }
        PortalButton(
            onClick = {
                val p = prefixoLimpo
                val n = nome.trim()
                executar("Tipo $p criado.") { OcorrenciasApi.criarTipo(p, n, tipoAcid) }
                prefixo = ""
                nome = ""
                tipoAcid = ""
            },
            enabled = prefixoLimpo.isNotEmpty() && nome.isNotBlank()
        ) { Text("Adicionar tipo") }
    }

    if (d.master) {
        CartaoSecao("Meta de dias sem acidente") {
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                Campo("Meta (dias)", meta, numero = true, modifier = Modifier.width(180.dp)) { meta = it.filter(Char::isDigit).take(6) }
                PortalButton(onClick = {
                    val v = meta.toIntOrNull() ?: return@PortalButton
                    executar("Meta salva.") { OcorrenciasApi.salvarMeta(v) }
                }, enabled = meta.toIntOrNull() != null) { Text("Salvar meta") }
            }
        }
        CartaoSecao(
            "Importar backup de ocorrências",
            subtitulo = "Arquivo .json no formato do portal de ocorrências. Só cria o que ainda não existe; nada é sobrescrito."
        ) {
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                PortalOutlinedButton(onClick = {
                    importando = true
                    scope.launch {
                        val arq = PlatformServices.pickJson()
                        if (arq == null) {
                            importando = false
                            return@launch
                        }
                        OcorrenciasApi.importar(arq.bytes.decodeToString())
                            .onSuccess { msg -> executar(msg) { Result.success(Unit) } }
                            .onFailure { avisar(it.message ?: "Falha ao importar.", PortalCores.Vermelho) }
                        importando = false
                    }
                }, enabled = !importando) { Text("Escolher arquivo .json") }
                if (importando) CircularProgressIndicator(modifier = Modifier.size(20.dp), strokeWidth = 2.dp)
            }
        }
    }

    corrigindo?.let { t ->
        PortalModal(onFechar = { corrigindo = null }, larguraMax = 480.dp) {
            CartaoSecao("Editar tipo ${t.prefixo}", subtitulo = "Trocar o prefixo renomeia os IDs já emitidos (ex.: OAT-001).") {
                Campo("Prefixo", prefixoCorrecao.uppercase().filter { it in 'A'..'Z' }.take(6), modifier = Modifier.fillMaxWidth()) {
                    prefixoCorrecao = it
                }
                Campo("Nome do tipo", nomeCorrecao, modifier = Modifier.fillMaxWidth()) { nomeCorrecao = it }
                Seletor(
                    "Típico / Trajeto padrão",
                    listOf("" to "Não definir", "Típico" to "Típico", "Trajeto" to "Trajeto"),
                    tipoAcidCorrecao,
                    { tipoAcidCorrecao = it }
                )
                Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    PortalOutlinedButton(onClick = { corrigindo = null }) { Text("Cancelar") }
                    PortalButton(
                        onClick = {
                            val n = nomeCorrecao.trim()
                            val p = prefixoCorrecao.uppercase().filter { it in 'A'..'Z' }.take(6)
                            if (n.isBlank() || p.isBlank()) {
                                avisar("Informe o prefixo e o nome do tipo.", PortalCores.Vermelho)
                                return@PortalButton
                            }
                            executar("Tipo ${t.prefixo} atualizado.") {
                                OcorrenciasApi.atualizarTipo(t.prefixo, n, tipoAcidCorrecao, t.ativo, p)
                            }
                            corrigindo = null
                        },
                        enabled = nomeCorrecao.trim().isNotEmpty()
                    ) { Text("Salvar") }
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Obras (efetivo)

@Composable
private fun AbaObrasOc(largo: Boolean, avisar: (String, Color) -> Unit) {
    val scope = rememberCoroutineScope()
    var dados by remember { mutableStateOf<EfetivoDados?>(null) }
    var carregando by remember { mutableStateOf(true) }
    var fid by remember { mutableStateOf("") }
    var cc by remember { mutableStateOf("") }
    var ini by remember { mutableStateOf("") }
    var busca by remember { mutableStateOf("") }
    var salvando by remember { mutableStateOf(false) }

    fun recarregar() {
        carregando = true
        scope.launch {
            EfetivoApi.dados()
                .onSuccess {
                    dados = it
                    if (ini.isBlank()) ini = Datas.br(it.hoje)
                }
                .onFailure { avisar(it.message ?: "Falha ao carregar o efetivo.", PortalCores.Vermelho) }
            carregando = false
        }
    }

    LaunchedEffect(Unit) { recarregar() }

    if (carregando && dados == null) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
            CircularProgressIndicator(modifier = Modifier.size(22.dp), strokeWidth = 2.dp)
            Text("Carregando funcionários e obras...", color = PortalCores.CinzaTexto)
        }
        return
    }

    val d = dados ?: return
    val ref = d.hoje
    val comObra = d.funcionarios.filter { f -> f.ativoEm(ref) && RegrasEfetivo.obraEm(f.aloc, ref) != null }
    val q = busca.trim()
    val filtrados = comObra.filter {
        q.isEmpty() || it.nome.contains(q, true) || it.matricula.contains(q) || it.funcao.contains(q, true)
    }
    val opcoesFunc = filtrados.map { f ->
        val ccAtual = RegrasEfetivo.obraEm(f.aloc, ref)
        f.id to "${f.nome} · ${d.rotulo(ccAtual)}"
    }
    val centrosAtivos = d.centros.filter { it.ativo }

    CartaoSecao(
        "Alterar obra do funcionário",
        subtitulo = "Lista só quem está ativo e já alocado em uma obra na data de hoje. A troca encerra o período anterior e abre a nova obra na data informada."
    ) {
        CampoBusca(busca, { busca = it }, "Filtrar por nome, matrícula ou função", Modifier.fillMaxWidth())
        Seletor("Funcionário", opcoesFunc, fid, { fid = it }, Modifier.fillMaxWidth())
        if (comObra.isEmpty()) {
            Text("Nenhum funcionário ativo com obra na data de referência.", color = PortalCores.CinzaTexto)
        } else if (opcoesFunc.isEmpty()) {
            Text("Nenhum resultado para o filtro.", color = PortalCores.CinzaTexto)
        }
        Par(
            largo,
            { m -> Seletor("Nova obra", centrosAtivos.map { it.id to it.rotulo }, cc, { cc = it }, m) },
            { m -> Campo("Início (dd/mm/aaaa)", ini, modifier = m) { ini = it } }
        )
        Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
            PortalButton(
                onClick = {
                    val iso = Datas.iso(ini)
                    when {
                        fid.isBlank() -> avisar("Selecione um funcionário.", PortalCores.Vermelho)
                        cc.isBlank() -> avisar("Escolha a nova obra.", PortalCores.Vermelho)
                        iso == null -> avisar("Data de início inválida.", PortalCores.Vermelho)
                        else -> {
                            salvando = true
                            scope.launch {
                                EfetivoApi.alocar(listOf(fid), cc, iso, trocar = true)
                                    .onSuccess { (n, recusados) ->
                                        if (recusados.isEmpty()) {
                                            avisar("Obra alterada para ${d.rotulo(cc)} a partir de ${Datas.br(iso)}.", PortalCores.Verde)
                                            recarregar()
                                        } else {
                                            avisar(recusados.joinToString("; "), PortalCores.Vermelho)
                                        }
                                    }
                                    .onFailure { avisar(it.message ?: "Falha ao alterar a obra.", PortalCores.Vermelho) }
                                salvando = false
                            }
                        }
                    }
                },
                enabled = !salvando && comObra.isNotEmpty()
            ) { Text(if (salvando) "Salvando..." else "Alterar obra") }
            PortalOutlinedButton(onClick = { recarregar() }, enabled = !salvando) { Text("Atualizar lista") }
        }
    }
}
